import { SITENAMEALIAS, ASSETS } from "./init";
import Swal from "sweetalert2";
import Header from "../components/Header";
import { FetchMerchantSettings } from "./service";

/*** function defination for storing current route ***/
export const storeCurrentRoute = (route) => {
  localStorage.setItem(SITENAMEALIAS + "_current_page", route);
};

/*** function defination for confirm message  ***/
export const showConfirm = (title, text, type, callback) => {
  const computedStyle = getComputedStyle(document.body);
  const bgColor = computedStyle.getPropertyValue("--popupbody-color").trim();
  const textColor = computedStyle.getPropertyValue("--text-color").trim();

  Swal.fire({
    html: `
      <div class="swal-header-banner">
        <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
          <line x1="12" y1="9" x2="12" y2="13"/>
          <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
      </div>
      <div class="swal-body-content">
        <h2 class="swal-body-title">${title}</h2>
        <p class="swal-body-text">${text}</p>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "Cancel",
    background: bgColor || "#ffffff",
    color: textColor || "#333333",
    reverseButtons: true,
    focusCancel: true,
    showCloseButton: false,
    customClass: {
      popup: "swal-confirm-popup",
      actions: "swal-confirm-actions",
      confirmButton: "swal-confirm-btn",
      cancelButton: "swal-cancel-btn",
    },
    buttonsStyling: false,
    showClass: {
      popup: "swal2-show swal-fade-in",
    },
    hideClass: {
      popup: "swal2-hide swal-fade-out",
    },
  }).then((result) => {
    if (result.value) {
      callback();
    }
  });
};

/*** function defination for showing toast ***/
export const showToast = (type, message) => {
  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    onOpen: (toast) => {
      //toast.addEventListener('mouseenter', Swal.stopTimer)
      //toast.addEventListener('mouseleave', Swal.resumeTimer)
    },
  });

  const iconHtmlMap = {
    info: '<i class="fa fa-info-circle" style="font-size:1.75em;color:#3fc3ee"></i>',
  };

  Toast.fire({
    icon: type,
    ...(iconHtmlMap[type] ? { iconHtml: iconHtmlMap[type] } : {}),
    title: message,
  });
};

/***  funtion defination for showing http error ***/
export const showHttpError = (error) => {
  if (error.response != undefined) {
    var code = error.response.status;
    // console.log('error status is:',error.response.status)
    // alert(error)
    // alert(code)
    //console.log('error',(error.toString()).indexOf('401'))
    /* if((error.toString()).indexOf('401')!= -1) {
      showToast('error','Authentication Failed')
      handleLogout();
    } */
    //console.log('error code ',error.response.code)

    if (code == "401" || error.toString().indexOf("401") != -1) {
      showToast("error", "Session Timeout");
      // handleLogout();
    } else if (code == "403") {
      showToast("error", "403 error");
      // handleLogout();
    } else if (code == "404" || code == "403" || code == "400") {
      showToast("error", "Failed to connect with the server");
    } else if (code == "500") {
      showToast("error", "Internal Server Error");
    } else {
      showToast("error", code + " : Technical Error");
    }
  } else {
    showToast("error", error);
  }
};

export const handleLogout = () => {
  localStorage.removeItem(SITENAMEALIAS + "_merchant_id");
  localStorage.removeItem(SITENAMEALIAS + "_first_name");
  localStorage.removeItem(SITENAMEALIAS + "_last_name");
  localStorage.removeItem(SITENAMEALIAS + "_email");
  localStorage.removeItem(SITENAMEALIAS + "_paybito_userid");
  localStorage.removeItem(SITENAMEALIAS + "_paybito_id");
  localStorage.removeItem(SITENAMEALIAS + "_access_token");
  localStorage.removeItem(SITENAMEALIAS + "_organization_name");
  localStorage.removeItem(SITENAMEALIAS + "_uuid");
  localStorage.removeItem(SITENAMEALIAS + "_phone_number");
  localStorage.removeItem(SITENAMEALIAS + "_paybito_password");
  localStorage.removeItem("_grecaptcha");
  localStorage.removeItem(SITENAMEALIAS + "_gcaptchaval");
  localStorage.removeItem(SITENAMEALIAS + "_theme");
  localStorage.clear();
  //  this.props.history.push("/");
  window.location.href = "/app/v2/ui/";
  //console.log(window.location.href)
  setTimeout(() => {
    window.location.reload();
  }, 2000);
};
/* Method defination for validating phone number */
export const _isValidPhoneNo = (param) => {
  //let pattern = /(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{3})(\s|-?))(\d{3}(\s|-?))(\d{4})(\s?(([E|e]xt[:|.|]?)|x|X)(\s?\d+))?/
  let pattern = /[0-9]{8,15}/;
  return pattern.test(param);
};
/* Method defination for validating zip code */
export const _isValidZipCode = (param) => {
  let pattern = /^[0-9]*$/gm;
  return pattern.test(param);
};
/* Method defination for checking only number */
export const _isOnlyNumber = (param) => {
  let pattern = /^([0-9]+\.?[0-9]*|\.[0-9]+)$/;
  return pattern.test(param);
};

/* Method defination for getting currency details */
export const handleCurrencyDetiails = (param) => {
  for (let i = 0; i < ASSETS.length; i++) {
    if (param == ASSETS[i].assetId || param == ASSETS[i].assetCode) {
      return ASSETS[i];
      break;
    }
  }
};
/* Method defination for getting currency details */
export const handleDynamicCurrencyDetiails = (assets, param) => {
  console.log(assets, param);
  for (let i = 0; i < assets.length; i++) {
    if (param == assets[i].assetId || param == assets[i].assetCode) {
      return assets[i];
      break;
    }
  }
};

/* Method defination for getting currency details */
export const handleNetworkDetails = (param) => {
  for (let i = 0; i < ASSETS.length; i++) {
    if (param == ASSETS[i].assetId || param == ASSETS[i].assetCode) {
      return ASSETS[i].network;
      break;
    }
  }
};

/* Method defination for getting currency details */
export const initialiseNetwork = (param) => {
  for (let i = 0; i < ASSETS.length; i++) {
    if (param == ASSETS[i].assetId || param == ASSETS[i].assetCode) {
      return ASSETS[i].network[0];
      break;
    }
  }
};

/* Method defination for formating amount */
export const formatAmount = (param, precision) => {
  let val = parseFloat(param).toFixed(precision);
  if (isNaN(val)) val = 0;
  return val;
};

/* Method defination for getting current page access */
export const currentPageAccess = () => {
  let permission = "READ";
  if (localStorage.getItem(SITENAMEALIAS + "_parent_merchant_id") != "0") {
    let currentPage = window.location.href;
    //console.log(currentPage);
    let curentPageArr = currentPage.split("/");
    let route = curentPageArr[curentPageArr?.length - 1];
    //console.log(route);
    let access = JSON.parse(
      localStorage.getItem(SITENAMEALIAS + "_access_list")
    );
    //console.log('access',access)
    for (let i = 0; i < access.length; i++) {
      if (access[i].url != undefined && access[i].url != null) {
        if (route == "basic-verification" || route == "crypto-address") {
          route = "get-started";
        }
        console.log(access[i].url.toLowerCase(), route.toLowerCase());
        if (access[i].url.toLowerCase() == route.toLowerCase()) {
          permission = access[i].access;
          break;
        }
      }
    }
  } else {
    permission = "WRITE";
  }
  console.log(permission);
  return permission;
};

export const getCurrencyWiseTxnCharge = async (currency) => {
  try {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };

    const res = await FetchMerchantSettings(payload);
    const response = res.data[0];

    if (response.error != "0") {
      showToast("error", response.error_msg);
      return null;
    }

    const currentPlanTxnCharges = response.TXN_CHARGES;
    const txnChargesArr = currentPlanTxnCharges.split(",");

    for (let i = 0; i < txnChargesArr.length; i++) {
      const iterArr = txnChargesArr[i].trim().split(" ");
      const asset = iterArr[0];
      const charge = iterArr[1];

      if (asset === currency) {
        return charge;       // ✅ matched — return the charge
      }
    }

    return null;             // ✅ no match found

  } catch (err) {
    console.log("err", err);
    showHttpError(err);
    return null;
  }
};


    // ─── Device ID + Browser Session ID ──────────────────────────────────────────
export const getDeviceId = async () =>  {
        const KEY = `${SITENAMEALIAS}_device_id`;

        // Try localStorage first (normal mode — fast path)
        const stored = localStorage.getItem(KEY);
        if (stored) return stored;

        // ── Only truly hardware-stable signals (unchanged in incognito) ──
        const signals = [
            // OS/platform only — strip browser name+version which differs in incognito
            navigator.platform || "",
            // CPU cores — hardware level, never changes
            String(navigator.hardwareConcurrency || ""),
            // Physical display — hardware level
            String(window.screen.width),
            String(window.screen.height),
            String(window.screen.colorDepth),
            String(window.screen.pixelDepth || ""),
            // System timezone — OS setting, unchanged
            String(new Date().getTimezoneOffset()),
            Intl.DateTimeFormat().resolvedOptions().timeZone || "",
        ];

        // ── Canvas fingerprint — KEY signal ──────────────────────────
        // Same GPU renders identical pixels in normal AND incognito mode
        // This is the primary differentiator between devices
        try {
            const canvas = document.createElement("canvas");
            canvas.width = 280;
            canvas.height = 60;
            const ctx = canvas.getContext("2d");

            // Background
            ctx.fillStyle = "#f0f0f0";
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // Text rendering (GPU-dependent)
            ctx.textBaseline = "alphabetic";
            ctx.font = "bold 16px Arial";
            ctx.fillStyle = "#284ccf";
            ctx.fillText("BillBitcoins_fp_2024", 10, 28);

            ctx.font = "italic 13px Georgia";
            ctx.fillStyle = "rgba(102,204,0,0.85)";
            ctx.fillText("🔒secure#checkout", 10, 48);

            // Geometry (anti-aliasing is GPU-specific)
            ctx.beginPath();
            ctx.arc(250, 30, 18, 0, Math.PI * 2);
            ctx.fillStyle = "rgba(40,76,207,0.4)";
            ctx.fill();

            signals.push(canvas.toDataURL());
        } catch (_) { }

        // ── WebGL renderer info — GPU model string ─────────────────────
        // Identical across normal/incognito, unique per GPU
        try {
            const gl = document.createElement("canvas").getContext("webgl")
                || document.createElement("canvas").getContext("experimental-webgl");
            if (gl) {
                const ext = gl.getExtension("WEBGL_debug_renderer_info");
                if (ext) {
                    signals.push(gl.getParameter(ext.UNMASKED_VENDOR_WEBGL) || "");
                    signals.push(gl.getParameter(ext.UNMASKED_RENDERER_WEBGL) || "");
                }
            }
        } catch (_) { }

        // ── djb2 hash ─────────────────────────────────────────────────
        const raw = signals.join("||");
        let h = 5381;
        for (let i = 0; i < raw.length; i++) {
            h = ((h << 5) + h) ^ raw.charCodeAt(i);
            h = h & h;
        }
        const id = "dev_" + (h >>> 0).toString(16).padStart(8, "0")
            + "_" + raw.length.toString(16);

        // Cache in localStorage (skipped automatically in incognito — re-derives same value)
        try { localStorage.setItem(KEY, id); } catch (_) { }

        return id;
    }

    export const getBrowserSessionId = async () => {
        const KEY = `${SITENAMEALIAS}_browser_session_id`;
        let id = sessionStorage.getItem(KEY);
        if (!id) {
            // Regenerates every new browser session (tab open / browser restart)
            id = "sess_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);
            sessionStorage.setItem(KEY, id);
        }
        return id;
    }

